import '@module/DebugMenu/DebugMenu.scss';
import { EventDispatcher, classList, documentReady, qs, slideDown, slideUp, storedItemCreate, storedItemRead } from '@utils/toolbox';

class DebugMenu {
	constructor () {
		this.elems = {
			menuContainer: qs('#debug-menu'),
			menuToggleButton: qs('#debug-menu-btn-toggle'),
			stats: qs('#debug-menu-stats'),
			tableBody: qs('.debug-menu__table tbody')
		};

		if (!this.elems.menuContainer) {
			return;
		}

		this.debugMenuState = storedItemRead('debug_menu_state') | 0;
		classList(this.elems.menuContainer).toggle('debug-menu--visible', this.debugMenuState);

		if (storedItemRead('debug_menu_state')) {
			classList(this.elems.stats).add('is-visible');
		}

		this.bindEvents();
	}

	bindEvents () {
		this.elems.menuToggleButton.addEventListener('click', async () => {
			console.log('debug menu toggle', !!this.debugMenuState);
			this.debugMenuState = !this.debugMenuState;

			await this.debugMenuState ? slideDown(this.elems.stats) : slideUp(this.elems.stats);
			storedItemCreate('debug_menu_state', this.debugMenuState);
			this.elems.menuContainer.classList.toggle('debug-menu--visible', this.debugMenuState);
		});
		EventDispatcher.addEventListener('debug:add', this.addRow.bind(this));
		EventDispatcher.addEventListener('debug:remove', this.removeRow.bind(this));
	}

	addRow (property, value) {
		this.removeRow(property);
		this.elems.tableBody.insertAdjacentHTML('beforeend', `<tr data-key="${property}"><td>${property}</td><td>${value}</td></tr>`);
	}

	removeRow (property) {
		qs(`[data-key="${property}"]`, this.elems.tableBody)?.remove();
	}
}

documentReady(() => {
	const debugMenu = new DebugMenu();
});
